export default "__VITE_ASSET__j4jwV8dE__"